<template>
    <sub-page :fullPage="true">
        <div class="excise-wrap">

            <div :span="24" class="excise-left">
                <data-tables class="form-table"
                             ref="recordTable"
                             :data="exciseTable"
                             :table-props="tableProps"
                             :current-page.sync="currentPage"
                             :page-size="20"
                             :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                             header-align="center"
                             v-loading="tableLoading"
                >
                    <el-table-column type="index" width="40" align="center"></el-table-column>

                    <el-table-column property="formName" :label="$t('stu.practiceMode')" align="center" show-overflow-tooltip
                                     sortable>
                    </el-table-column>
                    <el-table-column property="total" :label="$t('stu.images')" align="center" show-overflow-tooltip
                                     sortable>

                    </el-table-column>
                    <el-table-column property="correct" :label="$t('count.rightNum')" align="center" show-overflow-tooltip
                                     sortable>
                    </el-table-column>
                    <el-table-column property="wrong" :label="$t('count.wrongNum')" min-width="120" align="center" show-overflow-tooltip
                                     sortable>

                    </el-table-column>
                    <el-table-column property="startTime" :label="$t('c.startTime')" min-width="120" align="center" show-overflow-tooltip
                                     sortable>

                    </el-table-column>
                    <el-table-column property="submitTime" :label="$t('c.endTime')" min-width="120" align="center" show-overflow-tooltip
                                     sortable>

                    </el-table-column>

                </data-tables>
            </div>
        </div>
    </sub-page>
</template>

<script>
import api from '@/api';

export default {
    props: {
        'userID': String,
        'searchData': String
    },
    data() {
        return {
            // 表格信息开始
            exciseTable: [],
            tableProps: {
                border: true,
                stripe: true,
                rowKey: row => row.id,
                height: "auto"
            },
            currentPage: 1,
            formSearch: {
                startTime: '',
                endTime: '',
                limit: -1
            },
            tableLoading: true,
        }
    },
    created() {
        this.$nextTick(() => {
            this.query();
        })
    },
    methods: {
        query() {
            this.currentPage = 1;
            let searchData = JSON.parse(this.searchData)
            let queryData = {
                startTime: searchData.startTime,
                endTime: searchData.endTime,
            };

            api.queryFiscanExciseStatsDetail(this.userID, queryData).then((res) => {
                if (res.package) {
                    this.exciseTable = res.package;
                }
                this.tableLoading = false;
            })

        },

    },
}
</script>

<style scoped lang="scss">
.excise-wrap {
    height: 100%;
    display: flex;
}

.excise-left, .excise-right {
    height: 100%;
    border: 1px solid #ebebed;

}

.excise-left {
    width: 100%;
    /*margin-right: 20px;*/
    padding: 10px;
}


.form-table {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 95%;
}

</style>
